import config from '@/config'

export default {
  combine: {
    confirm_password: "确认密码",
    change_password: "更改密码",
    old_password: "旧密码",
    new_password: "新密码",
    confirm_security_code: "确认安全代码",
    first_time_login: "首次登录",
    security_authentication: "安全认证",
    update_security: "更新安全性",
    disable_security: "禁用安全性",
    add_account: "添加操作员",
    add_sub_account: "添加子账户",
    edit_operator: "编辑运营商",
    edit_account: "编辑操作员",
    edit_member: "编辑会员",
    approve_ticket: "批准工单",
    reject_ticket: "拒绝工单",
    add_bank_account: "添加银行账户",
    edit_bank_account: "编辑银行账户",
    reset_threshold: "重置阈值",
    adjust_balance: "调整余额",
    adjust_member: "调整会员",
    configure_bank_setting: "配置银行设置",
    account_setup: "账户设置",
    bank_transfer: "银行转账",
    edit_bank_member: "编辑会员银行",
    edit_ticket: "编辑工单",
    edit_vip: "编辑VIP",
    knock_off_promo: "撤销充值活动",
    edit_authority: "编辑权限",
    reset_password: "重置密码",
    update_password: "更新密码",
    member_summary: "会员摘要",
    reply_review: "回复评论",
    edit_affiliate: "编辑代理",
    edit_bank_affiliate: "编辑银行代理",
    approve_affiliate_ticket: "批准代理工单",
    check_free_spin: "检查免费旋转",
    reject_affiliate_ticket: "拒绝代理工单",
    wallet_adjust: "钱包调整",
    update_comm_package: "更新佣金套餐",
    approve_affiliate: "批准代理",
    sub_acc_detail_affiliate: "子账户详细信息代理",
    get_tac: "获取OTP",
    add_coupon: "添加优惠券",
    update_coupon: "更新优惠券",
    issue_free_spin: "发放免费旋转",
    get_bank_tac: "获取银行OTP",
    update_global_setting: "更新全局设置",
    add_platform: "添加平台",
    edit_platform: "编辑平台",
    add_bank_group: "添加银行组",
    edit_bank_group: "编辑银行组",
    update_maintenance_schedule: "更新维护计划",
    add_withdrawal_limit: "添加提款限额",
    edit_withdrawal_limit: "编辑提款限额",
    add_campaign: "添加活动",
    edit_campaign: "编辑活动",
    add_promo_group: "添加充值活动组",
    edit_promo_group: "编辑充值活动组",
    update_team: "更新团队",
    update_result: "更新结果",
    insert_result: "插入结果",
    bet_list: "投注列表",
    result_list: "结果列表",
    add_promo: "添加充值活动",
    raise_deposit_ticket: "提高存款工单",
    bank_adjust: "银行调整",
    promo_member_assign: "充值会员分配",
    bonus_issue: "发放奖金",
    update_vip: "更新VIP",
    update_member_profile: "更新会员资料",
    change_withdrawal_limit: "更改提款限额",
    change_bank_group: "更改银行组",
    change_promotion_group: "更改充值活动组",
    edit_promo_signup: "编辑注册体验金",
    update_provider_bet_limit: "更新提供商投注限额",
    update_bet_limit: "更新投注限额",
    update_member_bet_limit: "更新会员投注限额",
    edit_bank_account_group: "编辑银行账户组",
    redeposit_ticket: "重新存款工单",
    edit_promotion_group: "编辑充值活动组",
    edit_promotion_group_norm: "编辑充值活动组规范",
    get_inbox_list: "获取收件箱列表",
    view_result_changes_detail: "查看结果更改详情",
    edit_promotion_signup: "编辑注册体验金",
    edit_bet_limit: "编辑投注限额",
    edit_provider_game_off: "编辑提供商游戏状态",
    edit_provider_rtp: "编辑提供商RTP",
    get_rebate: "获取返利",
    get_recent_deposit: "获取最近存款",
    add_survey: "添加调查",
    add_announcement_banner: "添加弹窗广告设置",
    edit_announcement_banner: "编辑弹窗广告设置",
    move_announcement_banner: "移动弹窗广告设置",
    add_promotion_banner: "添加促销活动图",
    edit_promotion_banner: "编辑促销活动图",
    unlink_banner: "解除关联",
    move_promotion_banner: "移动促销活动图",
    add_slide_banner: "添加首页轮播图",
    edit_slide_banner: "编辑首页轮播图",
    move_slide_banner: "移动首页轮播图",
    add_seo_page: "添加SEO页面",
    edit_seo_page: "编辑SEO页面",
    clear_outstanding: "清除未结金额",
    add_ip_whitelist: "添加IP白名单",
    bonus_issue_bulk: "批量发放奖金",
    edit_bank_member_ewallet: "编辑会员银行(电子钱包)",
    redeposit: "重新存款",
    reject_approved_ticket: "拒绝已批准的工单",
    audit_ticket: "审核工单",
    review_ticket: "审查工单",
    edit_promotion_group_norm_seq: "编辑充值活动组规范顺序",
    edit_promo_provider_list: "编辑充值活动供应商列表",
    edit_promo_payment_option: "编辑充值活动付款选项",
    edit_campaign_provider_list: "编辑活动供应商列表",
    update_comm: "更新佣金",
    update_carry_over: "更新结转",
    review_affiliate_ticket: "审查代理工单",
    audit_affiliate_ticket: "审核代理工单",
    get_tac_affiliate: "获取OTP(代理)",
    raise_deposit_ticket_gateway: "提出存款票务(网关)",
    direct_audit_ticket: "审核工单(直接)",
    get_rollback_detail: "获取回滚详情",
    get_reject_detail: "获取拒绝详情",
    manual_approve_ticket: "批准工单(手动)",
    add_label: "添加标签",
    edit_label: "编辑标签",
    rollback_processing_ticket: "回滚处理中工单",
    update_iframe_url: "更新内嵌框架网址",
    edit_exchange_rate: "编辑汇率",
    add_vip: "添加VIP",
    add_turnover_tier: "添加返水层级",
    edit_turnover_tier: "编辑返水层级",
    edit_mission_reward: "编辑任务奖励",
    enable_mission_reward: "启用任务奖励",
    get_member_label_list: "会员标签列表",
    add_rescue_fund: "添加救援基金",
    get_custom_member_list: "定制会员列表",
    get_rescue_fund_provider: "获取救援基金供应商",
    add_game_exclude: "添加游戏下架",
    delete_game_exclude: "删除排除的游戏",
    domain_custom_add_assign: "添加域名",
    add_domain_batch: "批量添加域名",
    update_payment_provider_vip: "更新支付服务商VIP",
    update_campaign: "更新活动",
    purchase_domain: "购买域名",
    apply_domain: "自备域名",
    edit_access_control: "编辑访问控制",
    add_domain: "添加域名",
    operator_wallet_adjust: "调整运营商钱包",
    update_payment_provider_desc: "更新支付提供商描述",
    add_package: "@:ui.add@:ui.package",
    edit_package: "@:ui.edit@:ui.package",
    add_theme_content: "@:ui.add@:ui.theme_content",
    edit_theme_content: "@:ui.edit@:ui.theme_content",
    add_theme: "@:ui.add@:ui.theme",
    edit_theme: "@:ui.edit@:ui.theme",
    add_color: "@:ui.add@:ui.color",
    edit_color: "@:ui.edit@:ui.color",
    add_content: "@:ui.add@:ui.content",
    edit_content: "@:ui.edit@:ui.content",
    delete_content: "@:ui.delete@:ui.content",
    update_setting: "@:ui.update@:ui.setting",
    add_theme_content_group: "@:ui.add@:ui.theme_content_group",
    edit_theme_content_group: "@:ui.edit@:ui.theme_content_group",
    add_bo_default_domain: "@:ui.add@:ui.bo_default_domain",
    edit_bo_default_domain: "@:ui.edit@:ui.bo_default_domain",
    update_theme: "@:ui.update@:ui.theme",
    update_menu: "@:ui.update@:ui.menu",
    update_game_menu: "@:ui.update@:ui.game_menu",
    update_special_menu: "@:ui.update@:ui.special_menu",
    update_setting_menu: "@:ui.update@:ui.setting_menu",
    update_profile_setting: "@:ui.update @:ui.profile_setting",
    update_operator_setting: "@:ui.update@:ui.operator_setting",
    add_social_account: "@:ui.add@:ui.social_account",
    edit_social_account: "@:ui.edit@:ui.social_account",
    add_site_info: "@:ui.add@:ui.site_info",
    edit_site_info: "@:ui.edit@:ui.site_info",
    add_ads: "@:ui.add@:ui.advertisement",
    edit_ads: "@:ui.edit@:ui.advertisement",
    edit_provider_hot_game: "@:ui.edit@:ui.provider@:ui.hot_game",
    edit_provider_new_game: "@:ui.edit@:ui.provider@:ui.new_game",
    edit_provider_popular_game: "@:ui.edit@:ui.provider@:ui.popular_game",
    edit_provider_featured_game: "@:ui.edit@:ui.provider@:ui.featured_game",
    setup_logo: "设置LOGO",
    add_livechat: "@:ui.add@:ui.livechat",
    update_livechat: "@:ui.update@:ui.livechat",
    provider_pt_operator_update: "运营商供应商PT更新",
    provider_pt_global_update: "全局供应商PT更新",
    payment_option_callback_update: "回调网址更新",
    change_payment_option_seq: "支付选项顺序",
    change_payment_mode_status: "支付选项状态更新",
    change_payment_option_recommend: "推荐支付选项",
    change_payment_option_credential: "支付选项凭证",
    change_payment_option_limit: "支付选项限额",
    change_payment_option_vip: "VIP 支付选项",
    add_mini_game: "@:ui.add@:ui.mini_game",
    edit_mini_game: "@:ui.edit@:ui.mini_game",
    add_mini_game_template: "@:ui.add@:ui.mini_game_template",
    edit_mini_game_template: "@:ui.edit@:ui.mini_game_template",
    edit_reward: "@:ui.edit@:ui.reward",
    gamify_update: "@:ui.update@:ui.reward",
    add_free_game_token: "@:ui.add@:ui.free_game_token",
    add_partners: "@:ui.add@:ui.partners",
    edit_partners: "@:ui.edit@:ui.partners",
    add_leaderboard: "@:ui.add@:ui.leaderboard",
    edit_leaderboard: "@:ui.edit@:ui.leaderboard",
    add_phone: "@:ui.add@:ui.phone",
    adjust_free_balance: "Adjust Free Balance",
    edit_ai_assistant: "@:ui.edit @:ui.ai_assistant",
    change_payment_option_desc: "付款选项说明",
    fund_transfer_provider: "资金转账提供商",
    manual_deposit: "手动存款",
    change_linkage_desc: "关联说明",
    change_linkage_risk_weight: "关联风险权重",
    add_promo_voucher: "@:ui.add @:ui.promotion_voucher",
    edit_promotion_voucher_end_date: "@:ui.edit @:ui.promotion_voucher @:ui.end_date",
    get_voucher_custom_member_list: "获取优惠券自定义会员列表",
    redeposit_ticket_voucher: "重新充值工单凭证",
    approve_ticket_voucher: "批准工单凭证",
    reject_ticket_voucher: "拒绝工单凭证",
    raise_deposit_ticket_voucher: "创建充值工单凭证",
    raise_deposit_ticket_voucher_gateway: "创建充值工单凭证（网关）",
    get_voucher_list: "获取凭证列表",
    get_message_list: "获取消息列表",
    edit_free_credit: "@:ui.edit @:ui.free_credit",
    knock_off_free_credit_member: "取消免费信用会员",
    free_credit_manual_assign: "免费信用手动分配",
    review_fcp_ticket: "审核免费信用供应商工单",
    audit_fcp_ticket: "稽核免费信用供应商工单",
    reject_fcp_ticket: "拒绝免费信用供应商工单",
    approve_fcp_ticket: "批准免费信用供应商工单",
    edit_trigger: "编辑触发器",
    edit_trigger_status: "编辑触发器状态",
    adjust_voucher_balance: "调整优惠券余额",
    clear_free_credit: "清除免费额度",
    add_deposit_tier: "新增存款等级",
    edit_deposit_tier: "编辑存款等级",
    add_leaderboard_banner: "新增排行榜横幅",
    edit_leaderboard_banner: "编辑排行榜横幅",
    add_referral_banner: "新增推荐横幅",
    edit_referral_banner: "编辑推荐横幅",
    edit_vip_icon: "编辑 VIP 图标",
    add_reward_rain: "新增 Reward Rain",
    edit_reward_rain: "编辑 Reward Rain",
    add_reward_rain_session: "新增 Reward Rain 场次",
    edit_reward_rain_session: "编辑 Reward Rain 场次",
    edit_reward_rain_session_end_date: "编辑 Reward Rain 场次结束日期",
    add_news: "新增新闻",
    edit_news: "编辑新闻",
  },
  short: {
    deposit_amount: "存款金额",
    base_amount: "基础金额",
    bonus_amount: "奖金金额",
    target_amount: "目标金额",
    knockoff_by: "击倒者",
    knockoff_date: "击倒日期",
    incoming_threshold: "内部金额阈值",
    incoming_frequency: "内部金额频率",
    outgoing_threshold: "出款金额阈值",
    outgoing_frequency: "出款金额频率",
    account_balance: "账户余额",
    claim_type: "领取类型",
    bonus_rate: "奖金比率",
    max_bonus: "最小奖金",
    rollover: "流水要求",
    criteria: "条件",
    start_time: "开始时间",
    end_time: "结束时间",
    monday: "星期一",
    tuesday: "星期二",
    wednesday: "星期三",
    thursday: "星期四",
    friday: "星期五",
    saturday: "星期六",
    sunday: "星期日",
    status: "状态",
    bonus_rate_percent: "奖金比例(%)",
    valid_turnover: "有效投注额",
    deposit_count: "存款次数",
    withdrawal_amount: "取款金额",
    withdrawal_count: "取款次数",
    adjustment_amount: "调整金额",
    referee_count: "推荐会员数",
    signup_count: "注册会员数",
    verified_count: "实名认证计数",
    active_member: "活跃会员",
    ftd_count: "首次存款次数",
    ftd_amount: "首次存款金额",
    working_date: "工作日期",
    recipient_bank_id: "目标银行ID",
    recipient_bank_acc_no: "目标银行账号",
    recipient_bank_acc_holder: "目标银行账号持有人",
    sender_bank: "发起银行",
    sender_bank_acc_no: "发起银行账号",
    sender_bank_acc_holder: "发起银行账号持有人",
    unique_login_count: "独特登录次数",
    unique_deposit_count: "独特存款次数",
    unique_withdrawal_count: "独特出款次数",
    second_deposit_count: "第二次存款次数",
    reject_date: "拒绝日期",
    processing_date: "处理日期",
    deposit_withdrawal_different: "存款取款差异",
    external_id: "外部ID",
    draft_version: "草稿版本",
    prod_version: "生产版本",
    purchased_date: "购买日期",
    completed_amount: "已完成金额",
    min_amount: "最低金额",
    max_amount: "最高金额",
    total_claimed_amount: "已领取总金额",
  },
  date_ranges: {
    0: "今天",
    1: "昨天",
    2: "这个月",
    4: "上个月",
  },
  langList: {
    EN: "英语",
    CN: "中文",
    PHP: "菲律宾语",
    esp: "西班牙语",
    RUS: "俄语",
    VI: "越南语",
    MS: "马来语",
    NE: "尼泊尔语",
    CT: "中文（台湾）",
    BN: "孟加拉语"
  },
  menulist: {
    home: "首页",
    hot: "热门游戏",
    slot_game: "老虎机游戏",
    casino: "赌场",
    sportsbook: "体育博彩",
    fishing: "捕鱼",
    lottery: "彩票",
    poker: "扑克",
    hash_game: "哈希游戏",
    sabong: "斗鸡",
    promotion: "充值活动",
    review: "评论",
    news: "新闻",
    live_stream: "直播",
    vip: "VIP等级",
    referral: "推荐",
    favourite: "收藏",
    mission: "任务 (迷你游戏)",
    spin: "转盘",
    leaderboard: "排行榜",
    account: "账户管理",
    deposit: "存款",
    withdrawal: "取款",
    bet_history: "投注历史",
    pending_status: "待处理状态",
    change_password: "更改密码",
    profile: "个人资料",
    banking_details: "银行信息",
    inbox: "信箱",
    voucher: "优惠券",
    wallet: "钱包",
    statement: "账单",
    download: "下载",
    game: "游戏",
    special: "特别",
    misc: "杂项",
    contact_us: "联系我们",
    e_sportsbook: "电子体育博彩",
    lotto: "乐透",
    p2p: "点对点",
    other: "其他",
    vip2: "VIP2",
    referral2: "推荐2",
    event: "活动",
    daily_reward: "每日奖励",
    play2earn: "边玩边赚",
    redemption: "兑换",
    card_board: "卡牌",
    lobby: "大厅",
    in_house: "内部",
    transfer: "转账",
    horse_racing: "赛马",
    register: "注册",
    login: "登录",
    transaction_history: "交易历史",
    bingo: "宾果",
    member: "所有会员",
    arcade: "街机",
    crash: "火箭博彩",
    freeplay: "免费玩",
    others: "其他",
  },

  ok: "确定",
  cancel: "取消",
  login: "登录",
  logout: "登出",
  add: "添加",
  edit: "编辑",
  delete: "删除",
  refresh: "刷新",
  action: "操作",
  id: "编号",
  name: "名称",
  all: "全部",
  search: "搜索",
  remove: "移除",
  save: "保存",
  account: "账户管理",
  settings: "设置",
  on: "开启",
  off: "关闭",
  new: "新建",
  clear: "清空",
  users: "用户",
  username: "用户名",
  password: "密码",
  created_on: "创建日期",
  active: "活跃",
  page_size: "页面大小",
  status: "状态",
  result: "结果",
  close: "关闭",
  back: "返回",
  show: "显示",
  login_id: "登录ID",
  date_time: "日期时间",
  ip_address: "IP地址",
  domain_name: "域名",
  browser_agent: "浏览器代理",
  action_by: "操作人",
  details: "详情",
  key: "键",
  value: "键值",
  from: "从",
  to: "到",
  type: "类型",
  criteria: "条件",
  log: "系统设置",
  report: "报表统计",
  security_tag: "安全标签",
  security_code: "安全代码",
  submit: "提交",
  disable: "禁用",
  operators: "运营商",
  members: "所有会员",
  account_id: "账户ID",
  confirm_password: "确认密码",
  full_name: "全名",
  contact_phone: "联系电话",
  contact_email: "联系电子邮件",
  dashboard: "仪表盘",
  sub_account: "子账户设置",
  authority_option: "权限选项",
  banks: "银行",
  login_ip : "登录IP",
  block: "封锁",
  profile_id: "档案ID",
  suspend: "禁提",
  deposit: "存款",
  withdrawal: "取款",
  bulk_withdrawal: "批量取款",
  rejected: "拒绝",
  processed: "已处理",
  pending: "待处理",
  member: "会员",
  amount: "金额",
  bank_acc_no: "银行帐号",
  deposit_date: "存款日期",
  deposit_method: "存款方式",
  approve: "批准",
  reject: "拒绝",
  remark: "备注",
  ticket_detail: "门票详细信息",
  promo: "充值活动",
  package: "套餐",
  created_date: "创建日期",
  currency: "货币",
  bank_acc_holder: "银行账户持有人",
  ref_no: "参考号",
  vip: "VIP等级",
  modified_date: "修改日期",
  modified_by: "修改者",
  bank_member: "会员银行",
  bank_operator: "银行运营商",
  bank_name: "银行名称",
  bank_acc_type: "银行账户类型",
  account_balance: "账户余额",
  threshold: "阈值",
  incoming: "收入",
  outgoing: "支出",
  frequency: "频率",
  reset_threshold: "重置阈值",
  adjust_balance: "调整余额",
  bank_from: "从银行",
  bank_to: "到银行",
  attachment: "附件",
  sender_bank: "发件银行",
  sender_bank_acc_no: "发送方银行帐号",
  sender_bank_acc_holder: "发件银行账户持有人",
  audit: "审计",
  action_status: "操作状态",
  action_date: "操作日期",
  promotion: "充值活动设置",
  promo_id: "充值活动ID",
  promo_name: "充值活动名称",
  package_id: "套餐ID",
  claim_type: "领取类型",
  bonus_rate: "奖金比率",
  max_bonus: "最大奖金",
  rollover: "流水倍数",
  start_date: "开始日期",
  end_date: "结束日期",
  adj_amount: "调整金额",
  promotion_member: "充值会员管理",
  on_going: "进行中",
  knock_off: "解除",
  all_ongoing: "全部进行中",
  deposit_amount: "存款金额",
  base_amount: "基础金额",
  bonus_amount: "奖金金额",
  target_amount: "目标金额",
  claim_date: "领取日期",
  accumulate_win: "累积赢",
  accumulate_turnover: "累积流水",
  bonus: "奖金",
  bonus_log: "奖金日志",
  member_id: "会员ID",
  before_balance: "交易前余额",
  transfer_amount: "转账金额",
  after_balance: "交易后余额",
  created_by: "创建者",
  bonus_name: "奖金名称",
  bonus_desc: "奖金描述",
  bonus_type: "奖金类型",
  add_promo: "添加充值活动",
  bonus_value: "奖金数值",
  attach_promo: "附加充值活动",
  daily_statement: "每日报表",
  working_date: "工作日期",
  opening_balance: "初始余额",
  turnover: "流水",
  valid_turnover: "有效流水",
  winlose: "赢输",
  withdrawal_amount: "取款金额",
  closing_balance: "结算余额",
  sub_total: "小计",
  grand_total: "总计",
  daily_winlose: "每日赢输",
  game_result_slots: "游戏结果(老虎机)",
  game_result_livecasino: "游戏结果(真人娱乐)",
  game_result_rebate: "游戏结果(返点)",
  game_result_sportsbook: "游戏结果(体育博彩)",
  game_result_cockfight: "游戏结果(斗鸡)",
  game_result_rescue: "游戏结果(救援)",
  game_result_others: "游戏结果(其他)",
  bet_count: "投注次数",
  result_id: "结果ID",
  bet_time: "投注时间",
  result_time: "结果时间",
  payout: "赔付",
  game_type: "游戏类型",
  game_name: "游戏名称",
  game_provider: "游戏提供商",
  reset: "重置",
  mode: "模式",
  balance: "余额",
  min_bal_knock_off_promo: "最低余额(自动解锁充值活动)",
  social_account: "社交账号",
  wechat: "微信",
  telegram: "Telegram",
  whatsapp: "Whatsapp",
  facebook: "脸书",
  instagram: "Instagram",
  login_log: "登录日志",
  platform: "平台",
  bank_statement: "银行对账单",
  transfer_date: "转账日期",
  detail: "详情",
  date: "日期",
  transfer_list: "转账列表",
  credit: "存款",
  badge: "徽章",
  debit: "取款",
  month: "月份",
  unblock: "解锁",
  unblock_member: "解锁会员",
  unblock_operator: "解锁运营商",
  referrer_id: "推荐人ID",
  referrer_code: "推荐人代码",
  referral_code: "推荐代码",
  bonus_and_adjustment: "奖金和调整",
  adjustment: "调整",
  incoming_amount_threshold: "收入金额阈值",
  outgoing_amount_threshold: "支出金额阈值",
  knock_off_by: "解锁者",
  knock_off_date: "解锁日期",
  total_turnover: "总流水",
  total_winlose: "总赢输",
  total_deposit: "总存款",
  total_member: "总会员",
  active_player: "活跃玩家",
  top_winner: "最高赢家",
  top_loser: "最高输家",
  winner: "赢家",
  loser: "输家",
  deposit_count: "存款次数",
  withdrawal_count: "取款次数",
  alert: "警告",
  incoming_threshold: "存款阈值",
  incoming_frequency: "存款频率",
  outgoing_threshold: "取款阈值",
  outgoing_frequency: "取款频率",
  reset_password: "重置密码",
  transfer: "转账",
  company_bank: "公司银行",
  company_bank_acc_no: "公司银行账号",
  company_bank_acc_holder: "公司银行账户持有人",
  registered_member: "注册会员",
  promotion_report: "充值活动报告",
  deposited_member: "存款会员",
  referred_member: "推荐会员",
  validated_on: "验证日期",
  first_deposit: "首次存款",
  reward: "奖励",
  inbox: "收件箱",
  manual_bonus: "手动奖金",
  review: "评论 | 评论",
  reviews: "评论",
  review_list: "评论列表",
  review_detail: "评论详情",
  reply_review: "回复评论",
  comment: "评论",
  reply: "回复",
  recipient_no: "收件人编号",
  question : "问题",
  rating: "评分",
  content: "内容",
  image: "图像",
  monthly_rating: "月度评分",
  affiliate: "代理",
  affiliate_list: "代理列表",
  affiliate_code: "代理代码",
  approved_by: "批准者",
  approved_date: "批准日期",
  bank_affiliate: "银行代理",
  bank_id: "银行ID",
  ticket_detail_affiliate: "票务代理详情",
  pending_application: "待处理申请",
  pending_review_withdrawal: "待处理和审查提款",
  unblock_affiliate: "解锁代理",
  wallet_adjust: "钱包调整",
  comm_package: "佣金套餐",
  affiliate_id: "代理ID",
  sub_account_detail: "子账户详情",
  daily_winlose_affiliate: "每日赢输(代理)",
  daily_deposit_affiliate: "每日存款(代理)",
  export_excel: "导出Excel",
  get_tac: "获取OTP",
  tac_code: "OTP代码",
  expiry_date: "过期日期",
  inactive: "无效",
  last_deposit_date: "最后存款日期",
  coupon: "优惠券",
  allocated: "已分配",
  claimed: "已索取",
  approved: "已批准",
  coupon_code: "优惠券代码",
  coupon_quota: "优惠券配额",
  current_allocated: "当前已分配",
  new_allocated: "新的已分配",
  update : "更新",
  copy: "复制",
  bonus_rate_percent : "奖金比率(%)",
  coupon_desc: "优惠券描述",
  both: "两者",
  issue_free_spin: "发放免费旋转",
  game: "游戏",
  max_win_amount: "最大赢取金额",
  utm_list: "UTM列表",
  search_by_member: "按会员搜索",
  campaign: "活动",
  deposited: "已存款",
  search_by_id: "按ID搜索",
  get_bank_tac: "获取银行OTP",
  bank_statement_daily: "银行对账单(每日)",
  transfer_type: "转账类型",
  audit_freebies_list: "审计免费赠品列表",
  acknowledge: "确认",
  submit_acknowledgement: "提交确认",
  is_ack: "是否确认",
  yes: "是",
  no: "否",
  audit_rescue_fund_list: "审计救援基金列表",
  global_setting: "全局设置",
  signup_ip: "注册IP",
  last_login_ip: "上次登录IP",
  last_login_time: "上次登录时间",
  link: "链接",
  is_default: "是否默认",
  is_public: "是否公开",
  bank_group: "银行组",
  set_default: "设为默认",
  group_id: "组ID",
  group_name: "组名",
  provider_maintenance: "供应商维护",
  provider_code: "供应商代码",
  provider_name: "供应商名称",
  withdrawal_limit: "取款限额",
  limit_id: "限额ID",
  limit_name: "限额名称",
  daily_amount: "每日金额",
  daily_frequency: "每日频率",
  promotion_id: "充值活动ID",
  promotion_name: "充值活动名称",
  withhold_bonus: "保留奖金",
  withhold_amount: "保留金额",
  withhold_amt: "保留金额",
  max_withdraw_amt: "最大提款金额",
  max_withdraw_amount: "最大提款金额",
  monday: "星期一",
  tuesday: "星期二",
  wednesday: "星期三",
  thursday: "星期四",
  friday: "星期五",
  saturday: "星期六",
  sunday: "星期日",
  start_time: "开始时间",
  end_time: "结束时间",
  day: "天 | 天数",
  coupon_status: "优惠券状态",
  campaign_id: "活动ID",
  campaign_name: "活动名称",
  promotion_group: "充值活动组",
  referee_list: "推荐人列表",
  account_verified: "账户已验证",
  verified_date: "验证日期",
  ticket_list: "票务列表",
  vip_id: "VIP ID",
  vip_name: "VIP名称",
  self_rebate_rate: "自返点率(%)",
  downline_rebate_rate: "下线返点率(%)",
  provider: "供应商",
  match_id: "比赛ID",
  home_team: "主队",
  away_team: "客队",
  home_team_new: "主队新",
  away_team_new: "客队新",
  updated_by: "更新者",
  updated_on: "更新日期",
  home_score: "主队得分",
  away_score: "客队得分",
  home_score_new: "主队得分新",
  away_score_new: "客队得分新",
  team: "球队",
  match_time: "比赛时间",
  match_round: "比赛轮次",
  home_group: "主队组",
  away_group: "客队组",
  match: "比赛",
  match_status: "比赛状态",
  insert: "插入",
  pin: "个人识别码",
  bet_list: "投注列表",
  result_list: "结果列表",
  bet_id: "投注ID",
  bet_home: "主队投注",
  bet_away: "客队投注",
  bet_on: "投注方向",
  min_deposit: "最低存款",
  min_withdrawal: "最低提款",
  raise_deposit_ticket: "提出存款票务",
  method: "方法",
  one_time_depositor: "首次存款者",
  current_month_non_depositor: "本月未存款者",
  current_month_no_login: "本月未登录",
  ticket_date: "票务日期",
  ftd_amount: "首存金额",
  bonus_issue: "奖金发放",
  promotion_summary: "充值活动总结",
  promotion_summary_detail: "充值活动总结（详细）",
  claim_frequency: "领取频率",
  provider_list: "供应商列表",
  platform_winlose: "平台输赢",
  adjustment_amount: "调整金额",
  referee_count: "推荐人数",
  category: "类别",
  update_vip: "更新VIP",
  promotion_signup: "注册体验金",
  provider_bet_limit: "供应商投注限制",
  update_member_bet_limit: "更新会员投注限制",
  bet_limit: "投注限制",
  sports_game: "体育/游戏",
  league_name: "联赛名称",
  home_team_name: "主队名称",
  away_team_name: "客队名称",
  wl_status: "输赢状态",
  available_bank_account: "可用银行账户",
  group_bank_account: "银行账户组",
  edit_bank_group: "编辑银行组",
  edit_bank_account_group: "编辑银行账户组",
  redeposit: "重新存款",
  upline: "上线",
  downline: "下线",
  available_promotion: "可用充值活动",
  group_promotion: "充值活动组",
  edit_promotion_group: "编辑充值活动组",
  edit_promotion_group_norm: "编辑充值活动组规范",
  balance_before: "余额变动前",
  balance_after: "余额变动后",
  signup_count: "注册人数",
  verified_count: "验证人数",
  active_member: "活跃会员",
  ftd_count: "首存人数",
  daily_summary_company: "每日总结(公司)",
  daily_summary_operator: "每日总结(运营商)",
  daily_summary_member: "每日总结(会员)",
  daily_ledger_operator: "每日分类账（运营商）",
  bonus_list: "奖金列表",
  ltd_date: "LTD日期",
  adjustment_log: "调整日志",
  get_inbox: "收件箱",
  is_claimed: "已领取",
  mix_parlay: "混合串联",
  event: "事件",
  result_changes_log: "结果变更日志",
  view_detail: "查看详细信息",
  total_referee: "总推荐人数",
  verified_signup: "已验证/报名",
  ftd: "首存",
  raw_msg: "原始消息",
  unselect_all: "取消全选",
  select_all: "全选",
  edit_bet_limit: "编辑投注限制",
  provider_game_off: "供应商游戏关闭",
  provider_hot_game: "供应商热门游戏",
  game_id : "游戏ID",
  game_list: "游戏列表",
  off_list: "关闭列表",
  provider_rtp: "供应商RTP",
  rtp: "RTP",
  signup_date: "注册日期",
  free_credit: "免费信用",
  downline_rebate: "下线返点",
  game_rebate: "游戏返点",
  rebate: "返点",
  ftd_date: "首存日期",
  provider_winlose_company: "供应商输赢(公司)",
  provider_winlose_operator: "供应商盈亏(运营商)",
  already_hit: "已达成",
  ongoing: "进行中",
  members_export: "会员(导出)",
  get_recent_deposit: "获取最近存款",
  recent_deposit: "最近存款",
  survey_list: "调查列表",
  modified_on: "修改日期",
  cms: "网站内容管理系统",
  announcement_banner: "弹窗广告设置",
  promotion_banner: "促销活动图",
  slide_banner: "首页轮播图",
  seo_page: "SEO 页面",
  en_title: "标题(英文)",
  cn_title: "标题(中文)",
  local_title: "标题(当地语言)",
  en_img: "图片(英文)",
  cn_img: "图片(中文)",
  local_img: "图片(当地语言)",
  before_login: "登录前",
  after_login: "登录后",
  en: "英文",
  move_up: "上移",
  move_down: "下移",
  banner_type: "横幅类型",
  default_order: "默认顺序",
  item_order: "项目顺序",
  title: "标题",
  banner_id: "横幅ID",
  order: "顺序",
  body: "正文",
  en_image: "图片(英文)",
  local_image: "图片(当地语言)",
  move: "移动",
  en_img_desktop: "桌面图片(英文)",
  cn_img_desktop: "桌面图片(中文)",
  local_img_desktop: "桌面图片(当地语言)",
  en_img_mobile: "手機图片(英文)",
  cn_img_mobile: "手機图片(中文)",
  local_img_mobile: "手機图片(当地语言)",
  login_required: "需要登录",
  new_window_tab: "新窗口/选项卡",
  current_page: "当前页面",
  target: "目标",
  event_filter: "事件筛选",
  alt: "替代文本",
  href: "超链接",
  image_desktop: "桌面图片",
  image_mobile: "移动图片",
  en_alt: "替代文本(英文)",
  local_alt: "替代文本(当地语言)",
  en_href: "超链接(英文)",
  local_href: "超链接(当地语言)",
  en_image_desktop: "桌面图片(英文)",
  active_period: "有效期",
  en_item: "项目(英文)",
  local_item: "项目(当地语言)",
  meta_title: "元标题",
  meta_keywords: "元关键字",
  meta_url: "元URL",
  meta_canonical: "元规范",
  meta_author: "元作者",
  meta_publisher: "元发布者",
  meta_lang: "元语言",
  meta_desc: "元描述",
  meta_image: "元图片",
  page: "页面",
  item: "项目",
  remove_desktop_image: "删除桌面图片",
  remove_mobile_image: "删除移动图片",
  page_name: "页面名称",
  login_date: "登录日期",
  ftd_amount_min: "最低首存金额",
  ftd_amount_max: "最高首存金额",
  fl_provider_code: "首次启动供应商",
  fl_game_id: "首次启动游戏ID",
  fl_game_name: "首次启动游戏名称",
  top_deposit: "最高存款",
  top_withdrawal: "最高提款",
  top_promotion: "最高充值活动",
  outstanding_balance: "未结算余额",
  last_update_time: "最后更新时间",
  trace: "追踪",
  trace_outstanding: "追踪未结算",
  outstanding: "未结算",
  clear_outstanding: "清除未结算",
  meta_image_url: "元图片URL",
  member_bonus: "会员奖金",
  crm_list: "客户关系管理列表",
  advance_search: "高级搜索",
  deposit_count_from: "存款计数从",
  deposit_count_to: "存款计数至",
  deposit_amount_from: "存款金额从",
  deposit_amount_to: "存款金额至",
  min_day_no_login: "最低不登录天数",
  min_day_no_deposit: "最低不存款天数",
  last_login: "最后登录",
  last_deposit: "最后存款",
  phone: "电话",
  email: "电子邮件",
  ip_whitelist: "IP白名单",
  ip: "IP",
  payment_option: "付款选项",
  payment_mode: "付款方式",
  payment_desc: "付款说明",
  success: "成功",
  failed: "失败",
  bank_member_ewallet: "会员银行(电子钱包)",
  processing: "处理中",
  recipient_bank_id: "收款银行ID",
  recipient_bank_acc_no: "收款银行帐号",
  ticket_auto_withdrawal_log: "票证日志(自动提款)",
  resubmit_ticket: "重新提交票证",
  ticket_export: "工单(导出)",
  export_deposit: "导出(存款)",
  export_deposit_all: "导出全部(存款)",
  export_withdrawal: "导出(提款)",
  export_withdrawal_all: "导出全部(提款)",
  export_member_all: "导出全部(会员)",
  processed_rejected: "已处理(拒绝)",
  channel: "渠道",
  influencer: "影响者",
  ticket_id: "工单ID",
  recommend: "推荐",
  sequence: "顺序",
  statement_info: "报表信息",
  slots: "老虎机",
  livecasino: "真人娱乐",
  sportsbook: "体育博彩",
  cockfight: "斗鸡",
  member_list: "会员列表",
  operator: "运营商",
  game_balance: "游戏余额",
  claim_limit: "领取限制",
  max_withdraw_multiple: "最大提款乘数",
  payment_gateway: "支付网关",
  min_limit: "最小限额",
  max_limit: "最大限额",
  total: "总数",
  rebate_summary: "返利总结",
  rebate_summary_daily: " 每日返利总结",
  rebate_member: "返利会员",
  self: "自己",
  system_balance: "系统余额",
  rejected_onload: "拒绝(装载)",
  no_bonus: "没奖金",
  audit_ticket: "审核工单",
  review_ticket: "审查工单",
  edit_promotion_group_norm_seq: "编辑促销组规范顺序",
  signup_bonus: "注册奖金",
  settlement_type: "结算类型",
  carry_over: "结转",
  comm_sports: "佣金(体育博彩)",
  comm_slots: "佣金(老虎机)",
  comm_livecasino: "佣金(真人娱乐)",
  comm_cockfight: "佣金(斗鸡)",
  comm_others: "佣金(其他)",
  update_comm: "更新佣金",
  update_carry_over: "更新结转",
  ewallet: "电子钱包",
  withdrawal_list: "提款列表",
  audit_withdrawal: "审核提款",
  daily_withdrawal: "每日提款",
  adjustment_log_affiliate: "调整日志(代理)",
  daily_statement_affiliate: "每日报表(代理)",
  earning: "收益",
  pnl: "收益与损失",
  review_affiliate_ticket: "审查代理工单",
  audit_affiliate_ticket: "审核代理工单",
  turnover_downline: "流水(下线)",
  valid_turnover_downline: "有效流水(下线)",
  winlose_downline: "输赢(下线)",
  bet_count_downline: "投注次数(下线)",
  turnover_member: "流水(会员)",
  valid_turnover_member: "有效流水(会员)",
  winlose_member: "输赢(会员)",
  bet_count_member: "投注次数(会员)",
  dashboard_affiliate: "仪表盘(代理)",
  total_agent: "总代理",
  top_turnover: "总流水",
  bonus_count: "奖金次数",
  deposit_amount_downline: "存款金额(下线)",
  deposit_count_downline: "存款次数(下线)",
  bonus_amount_downline: "奖金金额(下线)",
  bonus_count_downline: "奖金次数(下线)",
  deposit_amount_member: "存款金额(会员)",
  deposit_count_member: "存款次数(会员)",
  bonus_amount_member: "奖金金额(会员)",
  bonus_count_member: "奖金次数(会员)",
  verified: "已验证",
  round_id: "回合ID",
  unfinish_round: "未完成的回合",
  smartico_bonus_report: "Smartico奖金报告",
  unclaimed_amount: "未领取金额",
  claimed_amount: "已领取金额",
  unclaimed_count: "未领取次数",
  claimed_count: "已领取次数",
  submit_time: "申请时间",
  deposit_time: " 到账时间",
  funds_list: "资金列表",
  fund_transfer_provider: "资金转账供应商",
  daifu_list_auto_withdrawal: "代付列表（自动提款）",
  btn_href: "按键超链接",
  btn_text: "按键文本",
  recent_inbox_claim: "最近收件箱领取",
  raise_deposit_ticket_gateway: "提出存款票务(网关)",
  gateway_acc: "网关户口",
  provider_winlose_member: "供应商输赢(会员)",
  review_by: "审查者",
  daifu_list_auto_withdrawal_export: "代付列表导出（自动提款）",
  retention: "保留",
  current_month_active_user: "当月活跃用户",
  current_month_active: "当月活跃",
  first_month: "第一个月",
  fmwinlose: "第一个月赢输",
  fmdeposit_amount: "第一个月存款金额",
  cohort: "队列",
  promotion_withdrawal_summary: "充值活动提款总结",
  promotion_withdrawal_summary_detail: "充值活动提款总结（详细）",
  unique_player: "独特的玩家",
  year: "年份",
  audit_time_modified: "审核时间",
  audit_time_created: "审核时间",
  approve_time: "批准时间",
  unique_login_count: "独特登录次数",
  unique_deposit_count: "独特存款次数",
  unique_withdrawal_count: "独特出款次数",
  second_deposit_count: "第二次存款次数",
  unique_login: "独特登录",
  unique_withdrawal: "独特出款",
  second_deposit: "第二次存款",
  deposit_withdrawal_different: "存款取款差异",
  ngr: "NGR",
  audit_list: "审核列表",
  rollback_count: "回滚次数",
  rejected_ticket_id: "已拒绝工单ID",
  rollback: "回滚",
  recipient_bank_acc_holder: "收款银行账户持有人",
  reject_date: "拒绝日期",
  processing_date: "处理日期",
  manual_approve: "批准（手动）",
  pending_review_funds: "待处理和审查资金",
  table_id: "桌子ID",
  member_label: "会员标签",
  label_name: "标签名称",
  label: "标签",
  available_label: "可用标签",
  iframe: "内嵌框架",
  iframe_url: "内嵌框架网址",
  exchange_rate: "汇率",
  rate: "汇率",
  rate_php: "PHP汇率",
  ticket_withdrawal_rollback: "提款工单回滚",
  smartico_bonus_report_expired: "Smartico奖金报告(已过期)",
  reward_type: "奖励类型",
  turnover_rebate: "流水回扣",
  turnover_rebate_1: "VIP层数",
  turnover_rebate_2: "返水设置",
  vip_cycle_day: "VIP周期日",
  is_addon: "添加",
  no_reward: "没有奖励",
  cash: "现金",
  cs: "客户服务",
  social_platform: "社交平台",
  edit_vip: "编辑VIP",
  edit_vip_provider: "编辑VIP供应商",
  turnover_tier: "返水设置",
  rebate_rate: "回扣率",
  edit_turnover_tier: "编辑返水层级",
  delete_turnover_tier: "删除返水层级",
  vip_log: "VIP日志",
  member_full_record: "会员完整记录",
  before: "前",
  after: "后",
  maintain: "保持",
  actual_rebate: "实际回扣",
  rounded_rebate: "四舍五入回扣",
  rebate_mode: "回扣模式",
  inbox_id: "收件箱ID",
  rebate_type: "回扣类型",
  promotion_type: "充值活动类型",
  bonus_rate_1: "一充(比率%)",
  bonus_rate_2: "二充(比率%)",
  bonus_rate_3: "三充(比率%)",
  bonus_rate_4: "四充(比率%)",
  bonus_rate_5: "五充(比率%)",
  bonus_rate_6: "六充(比率%)",
  bonus_rate_7: "七充(比率%)",
  bonus_rate_8: "八充(比率%)",
  bonus_rate_9: "九充(比率%)",
  bonus_rate_10: "十充(比率%)",
  delete_all: "全部删除",
  rescue_fund: "救援基金",
  up: "上",
  down: "下",
  rate_percent: "比率%",
  cycle: "周期",
  actual_amount: "实际金额",
  rounded_amount: "四舍五入金额",
  rescue_id: "救援ID",
  rescue_name: "救援名称",
  min_lose: "最小损失",
  max_payout: "最大支付",
  payout_method: "支付方式",
  target_group: "目标组",
  member_vip_id: "会员VIP ID",
  daily: "每日",
  weekly: "每周",
  monthly: "每月",
  edit_batch: "编辑批次",
  current_level: "当前等级",
  next_level: "下个等级",
  bet_value: "投注值",
  line_bet: "线注",
  total_round: "总回合",
  audit_by: "审核者",
  possible_next_level: "下个可能等级",
  maintain_deposit: "保持存款",
  maintain_turnover: "保持流水",
  starting_deposit: "初始存款",
  starting_turnover: "初始流水",
  cycle_deposit: "周期存款",
  cycle_turnover: "周期流水",
  vip_list: "VIP列表",
  up_maintain: "向上维护",
  down_lowest: "降到最低",
  manual: "手动",
  daily_winlose_game: "每日输赢(游戏)",
  actionaff: "操作(代理)",
  onload: "加载时",
  update_status: "更新状态",
  role_settings: "角色设置",
  customer_services: "客户服务",
  marketing: "营销",
  finance: "财务",
  payment: "支付",
  risk_management: "风险管理",
  pt: "游戏费率",
  wallet_history: "钱包历史",
  ticket_amount: "票金额",
  ignore_risk: "忽略风险",
  permitted_amount: "允许金额",
  all_pending_ticket: "所有待处理票",
  rescue_fund_summary: "救援基金摘要",
  rescue_fund_summary_daily: "每日救援基金摘要",
  rescue_fund_member: "救援基金会员",
  master: "主账户",
  account_type: "账户类型",
  freeze: "冻结",
  domain_member_setup: "会员站点域名设置",
  domain: "域名",
  domain_list: "开站配置",
  domain_application: "自备域名申请状态",
  domain_status: "域名状态",
  domain_group: "域名分组",
  operator_id: "运营商ID",
  domain_type: "域名类型",
  module: "模块",
  template: "模板",
  custom: "自定义",
  default: "默认",
  payment_provider: "支付服务商",
  payment: "支付",
  deactivate: "停用",
  name_server: "域名服务器",
  server_account: "服务器账户",
  service_provider: "服务商",
  process: "流程",
  provider_operator: "供应商运营商",
  bet_limit_member: "@:ui.bet_limit (@:ui.member)",
  global: "全局设置",
  second_id: "第二个ID",
  unverified: "未验证",
  pt_affiliate: "代理平台收費 (%)",
  recipient_bank: "目标银行",
  deposit_type: "存款类型",
  security_fund: "保证金",
  adjust_balance_op: "调整运营商钱包",
  adjust_security_deposit_op: "调整操作员保证金",
  marquee: "轮播展示消息",
  marquee_content: "轮播展示消息内容",
  edit_marquee: "编辑轮播展示消息",
  domain_available: "域名可用",
  daily_withdrawal_frequency: "每日提款频率",
  maintenance: "维护",
  max_withdrawal: "最大提款",
  min_balance: "最低余额",
  affiliate_report: "代理报告",
  cash_balance: "现金余额",
  copy_success: "复制成功！",
  copy_failed: "复制失败！",
  your_website: "您的网站",
  correction_promo: "添加充值活动",
  others: "其他",
  audit_log: "Audit Log",
  view: "查看",
  price: "价格",
  package_level: "套餐等级",
  bo_right: "后台权限",
  english: "英文",
  simplified_chinese: "简体中文",
  traditional_chinese: "繁体中文",
  philippine: "菲律宾语",
  thai: "泰语",
  vietnamese: "越南语",
  indonesian: "印尼语",
  myanmar: "缅甸语",
  japanese: "日语",
  korean: "韩语",
  package_type: "套餐类型",
  full_back_office_access_right: "完整后台访问权限",
  read_only_back_office: "只读后台",
  language: "语言",
  lang_code: "语言代码",
  description: "描述",
  provider_type: "提供商类型",
  logo: "徽标",
  theme_provider: "主题提供商",
  theme_content: "主题内容",
  content_id: "内容ID",
  content_desc: "内容描述",
  theme_content_position: "主题内容位置",
  theme: "主题",
  theme_code: "主题代码",
  theme_name: "主题名称",
  color: "颜色",
  position: "位置",
  site_name: "网站名称",
  theme_color: "主题颜色",
  theme_purchased: "主题已购买",
  total_purchased: "购买总数",
  purchased_date: "购买日期",
  purchase: "购买",
  total_site: "总站点",
  content_setup: "内容设置",
  site_list: "网站列表",
  site_id: "网站 ID",
  draft_version: "草稿版本",
  prod_version: "生产版本",
  production_version: "生产版本",
  info: "信息",
  setting: "设置",
  site_info: "网站底部消息",
  menu: "菜单",
  game_menu: "游戏菜单",
  special_menu: "特别菜单",
  setting_menu: "设置菜单",
  error: "错误",
  sync_all: "全部同步",
  theme_content_group: "主题内容组",
  content_group: "内容组",
  content_group_desc: "内容组描述",
  parent_content_id: "上级内容ID",
  bo_default_domain: "后台默认域名",
  domain_id: "域名ID",
  deactive: "停用",
  site_sync: "网站同步",
  upload: "上传",
  comingSoon: "即将到来",
  profile_setting: "个人资料设置",
  bank: "银行",
  company: "公司",
  own: "自有",
  operator_setting: "操作员设置",
  external_id: "外部ID",
  ticket: "工单",
  bank_owner: "银行账户持有人",
  exchanged_currency: "兑换的货币",
  company_bank_owner: "公司银行账户持有人",
  ticket_list_member: "玩家财务管理",
  game_name_exclude: "游戏下架",
  tab: "标签",
  about_us: "关于我们",
  privacy_policy: "隐私政策",
  responsible_gaming: "负责任的博彩",
  banking: "银行业务",
  faqs: "常见问题",
  advertisement: "三方埋点",
  px_pixel_id: "PX Pixel ID",
  px_token: "PX Token",
  af_dev_key: "Af Dev Key",
  af_apps_id: "Af Apps ID",
  pp_tid: "PP TID",
  pp_pid: "PP PID",
  pp_aid: "PP AID",
  gtm_id: "GTM ID",
  service_provider_url: "服务提供商网址",
  script_inject: "脚本注入",
  head_script: "头部脚本",
  body_script: "主体脚本",
  ads_id: "三方埋点ID",
  member_detail: "会员详情",
  memberreport: "会员报告",
  member_log: "会员日志",
  general: "通用",
  top_theme: "顶部主题",
  hot_game: "热门游戏",
  hot_list: "热门列表",
  new_game: "新游戏",
  popular_game: "热门游戏",
  featured_game: "精选游戏",
  new_list: "新列表",
  popular_list: "热门列表",
  featured_list: "精选列表",
  provider_new_game: "提供商新游戏",
  provider_popular_game: "提供商热门游戏",
  provider_featured_game: "提供商精选游戏",
  website: "网站配置",
  site_customization: "网站定制",
  export_all: "导出全部",
  export_one: "导出(当前页面)",
  daily_ledger: "每日分类账",
  daily_ledger_member: "每日分类账(会员)",
  promotion_signup_unused: "未使用注册彩金",
  promotion_signup_ongoing: "使用中的注册彩金",
  promotion_signup_winlose: "注册体验金输赢",
  promotion_signup_winlose_operator: "注册体验金输赢（运营商）",
  promotion_signup_winlose_member: "注册体验金输赢 (会员)",
  total_player_balance: "平台余额",
  search_all: "搜尋全部",
  mbsetting: "玩家充提规则",
  todays_highlights: "今日亮点",
  deposit_player: "存款会员",
  withdrawal_player: "取款会员",
  kill_rate: "杀率",
  login_player: "登录会员",
  operation_management: "运营管理",
  game_management: "游戏管理",
  member_management: "会员管理",
  affiliate_management: "代理管理",
  promotion_management: "活动管理",
  mbcampaign: "活动设置",
  promo_allday: "每次存款优惠",
  promo_daily: "每日存款优惠",
  promo_daily_first_deposit: "每日首存优惠",
  promo_deposit_monthly: "每月存款次数优惠",
  promo_deposit_signup: "存款次数优惠（新注册）",
  promo_deposit_weekly: "每周存款次数优惠",
  promo_newbie: "新人优惠",
  promo_once: "单次优惠",
  dd_review: "审查",
  game_provider_management: "游戏厂商管理",
  exchanged_amount: "兑换的金额",
  operator_summary: "操作员总结",
  business_id: "商户ID",
  game_name_exclude_log: "游戏下架日志",
  cn: "中文（简体）",
  local: "当地",
  taken: "已接收",
  receiver_bank: "收款银行",
  receiver_bank_acc_no: "收款银行账号",
  receiver_bank_acc_holder: "收款银行账号持有人",
  add_balance: "添加余额",
  deduct_balance: "扣除余额",
  sync_site_content: "同步网站内容",
  payment_setting: "付款设置",
  payment_own: "自定义",
  payment_global: "全局设置",
  livechat: "在线客服",
  chat_id: "客服许可证密钥",
  chat_provider: "客服提供商",
  auto_cycle: "循环",
  auto_all: "全部",
  completed_amount: "已完成金额",
  website_launched: "网站已上线",
  total_operators: "运营商总数",
  today_active: "今日活跃",
  new_player_verified_signup: "新玩家验证/注册",
  total_players: "玩家总数",
  depo_withdrawal_diff: "存取款差额",
  claim_count: "领取次数",
  ggr: "总博彩收入 (GGR)",
  member_balance: "会员余额",
  players: "玩家",
  provider_pt: "提供商PT",
  base: "基本",
  topup_id: "充值ID",
  credential: "凭证",
  credential_1: "凭证 1",
  credential_2: "凭证 2",
  credential_3: "凭证 3",
  credential_4: "凭证 4",
  credential_5: "凭证 5",
  credential_6: "凭证 6",
  credential_7: "凭证 7",
  credential_8: "凭证 8",
  credential_9: "凭证 9",
  credential_10: "凭证 10",
  limit: "限制",
  create: "创建",
  hint: "提示",
  quickSetup: "快速开站",
  next: "下一步",
  setUpTheme: "设置主题",
  checkOut: "结算",
  standardPackage: "标准配套",
  siteName: "网站名称",
  information: "商品信息",
  useThisTemplate: "使用此模板",
  summary: "摘要",
  createOperatorAccount: "创建运营账号",
  operatorId: "运营账号",
  operatorPwd: "运营密码",
  new_website: "新网站",
  operator_information: "运营商信息",
  bo_link: "后台链接",
  daily_summary_sms: "每日短信摘要",
  daily_summary_sms_operator: "每日短信摘要（运营商）",
  daily_summary_sms_operator_detail: "每日短信摘要详情（运营商）",
  sms_count: "短信数量",
  provider_winlose_operator_pt: "供应商盈亏(运营商游戏费率)",
  pt_on: "收费条件",
  share_operator: "站点收益",
  share_company: "包网收费",
  token_log: "代币日志",
  template_code: "模板代码",
  template_name: "模板名称",
  mini_game: "迷你游戏",
  max_game_reward: "游戏最高奖励",
  max_chance_per_day: "每日最高机会",
  is_recurring_chance: "重复",
  token_request: "令牌",
  enabled: "启用",
  disabled: "禁用",
  unlimited: "无限",
  max_chance_unlimited: "每日最高机会无限",
  mini_game_template: "小游戏模板",
  reward_code: "奖励代码",
  reward_name: "奖励名称",
  reward_description: "奖励描述",
  reward_probability: "奖励概率",
  total_game: "总游戏",
  total_played_mini_game: "总共玩过的迷你游戏",
  total_played_mini_game_detail: "总共玩过的迷你游戏详细信息",
  total_played_mini_game_detail_operator: "总共玩过的迷你游戏详细信息（运营商）",
  daily_pnl_operator: "每日P&L（运营商）",
  token: "代币",
  token_1: "代币 1",
  token_2: "代币 2",
  token_3: "代币 3",
  token_4: "代币 4",
  token_5: "代币 5",
  token_6: "代币 6",
  token_7: "代币 7",
  cash_1: "现金 1",
  cash_2: "现金 2",
  cash_3: "现金 3",
  cash_4: "现金 4",
  cash_5: "现金 5",
  cash_6: "现金 6",
  cash_7: "现金 7",
  daily_login: "每日签到（每日登录）",
  daily_login_update: "每日签到（每日登录）更新",
  game_result_reward: "游戏结果奖励",
  current_streak: "当前连胜",
  login_streak: "连续登录",
  total_token: "代币总数",
  total_mini_game_token_used: "迷你游戏使用代币总数",
  total_mini_game_token_used_detail: "迷你游戏使用代币总数明细",
  total_mini_game_token_used_detail_operator: "迷你游戏使用代币总数明细（运营商）",
  total_reward: "总奖励",
  total_mini_game_reward: "迷你游戏奖励总额",
  total_mini_game_reward_detail: "迷你游戏奖励总额明细",
  total_mini_game_reward_detail_operator: "迷你游戏奖励总额明细（运营商）",
  token_balance: "代币余额",
  free_game_token: "免费游戏代币",
  bo_url: "后台网址",
  copied: "已复制",
  callback: "回调",
  api: "API",
  prefix: "前缀",
  delimiter: "分隔符",
  url_callback_deposit: "充值回调地址",
  url_callback_withdrawal: "提现回调地址",
  url_callback_affiliate: "代理回调地址",
  url_api_deposit: "充值回调地址（API）",
  url_api_withdrawal: "提现回调地址（API）",
  url_api_balance: "余额回调地址（API）",
  prefix_deposit: "充值前缀",
  prefix_withdrawal: "提现前缀",
  prefix_affiliate: "代理前缀",
  prefix_delimiter: "前缀分隔符",
  merchant: "商户",
  app_id: "应用 ID",
  secret_key: "密钥",
  deposit_secret_key: "充值密钥",
  withdrawal_secret_key: "提现密钥",
  partners: "合作伙伴",
  partner_name: "合作伙伴名称",
  win: "赢",
  manifest: "清单",
  crop: "裁剪",
  cropImage: "裁剪图片",
  api_url: "API 地址",
  start_date_time: "开始日期时间",
  end_date_time: "结束日期时间",
  authentication_key: "认证密钥",
  one_week: "1周",
  two_week: "2周",
  one_month: "1个月",
  two_month: "2个月",
  six_month: "6个月",
  edit_promotion_end_date: "编辑促销结束日期",
  android_app_link: "Android 应用链接",
  add_android_app_link: "添加 Android 应用链接",
  operator_details: "运营商详情",
  bsb: "BSB",
  payid: "Pay ID",
  cuit: "CUIT",
  merchant_key: "商户密钥",
  aes_key: "AES密钥",
  paycode: "支付码",
  api_key: "API密钥",
  referral: "推荐奖励",
  minimum_deposit: "最低存款",
  minimum_withdrawal: "最低提款",
  maximum_withdrawal: "最高提款",
  cpi: "CPI",
  cpi_enrol: "CPI 注册",
  interested: "感兴趣",
  non_pickup: "未领取",
  invalid: "无效",
  cpi_member_list: "CPI 成员列表",
  leaderboard: "排行榜",
  capacity: "容量",
  reward_count: "奖励数量",
  is_settled: "已结算",
  settlement_date: "结算日期",
  prize: "奖品",
  count: "数量",
  multiplier: "倍数",
  ranking: "排名",
  leaderboard_ranking: "排行榜排名",
  joined_date: "加入日期",
  ready: "准备就绪",
  busy: "忙碌",
  phone_list: "电话号码列表",
  single: "单个",
  batch: "批量",
  cpi_operator_phone_list: "CPI运营商电话号码列表",
  selected: "已选择",
  call: "呼叫",
  private_key: "私钥",
  public_key: "公钥",
  multi_call: "多次呼叫",
  add_custom: "添加自定义",
  custom_list: "自定义列表",
  assignee: "被指派人",
  urgency: "紧急程度",
  urgency_1: "低",
  urgency_2: "中等",
  urgency_3: "高",
  edit_custom: "编辑自定义",
  cpi_custom_list: "CPI 自定义列表",
  free_coin_signup: "免费点数（注册）",
  free_coin_daily: "免费点数（每日）",
  free_coin_min_withdrawal: "最低提现（免费点数）",
  free_coin_per_unit: "免费点数汇率（点数 = {currency} 1）",
  adjust_free_balance: "调整免费余额",
  adjust_free_balance_log: "免费余额记录",
  signup: "注册",
  adjust: "调整",
  ai_assistant: "AI助手",
  en_name: "名称 (EN)",
  cn_name: "名称 (CN)",
  local_name: "名称 (本地)",
  img_small: "图片 (小)",
  img_large: "图片 (大)",
  small_image: "小图",
  large_image: "大图",
  forgot_password: "忘记密码",
  update_password: "更新密码",
  contact: "联系方式",
  keyss: "键",
  iv: "IV",
  callback_public_key: "回调公钥",
  free_game: "免费游戏",
  version_no: "版本号",
  client_id: "客户端ID",
  symmetric_key: "对称密钥",
  deposit_token: "存款令牌",
  withdrawal_token: "提款令牌",
  tac_bank: "验证码（银行）",
  tac_login: "验证码（登录）",
  tac_signup: "验证码（注册）",
  tac_signup_aff: "验证码（加盟注册）",
  merchant_name: "商户名称",
  tele_status: "Tele 状态",
  follow_up: "后续跟进",
  call_type: "通话类型",
  on_call_list: "在通话列表中",
  inbox_valid_day: "收件箱有效天数",
  manual_deposit: "手动存款",
  withdrawal_result: "提现结果",
  widget_id: "小部件 ID",
  property_id: "属性 ID",
  referee: "被推荐人奖励",
  game_result_free_slots: "游戏结果（免费老虎机）",
  crypto_address: "加密地址",
  crypto_network: "加密网络",
  crypto: "加密货币",
  exchange_currency: "兑换货币",
  base_rate: "基础汇率",
  white_label: "White Label",
  aggregator: "聚合商",
  deposit_rate: "存款费率",
  withdrawal_rate: "提款费率",
  pending_bet_list_wbet: "待处理投注列表（WBET）",
  bet_amount: "投注金额",
  actual_bet_amount: "实际投注金额",
  pending_bet_list_others: "待处理投注列表（其他体育博彩）",
  dob: "出生日期",
  mail_address: "邮寄地址",
  crypto_withdrawal: "加密货币提款",
  institute_bank_code: "机构银行代码",
  pending_bet_list_9w: "待处理投注列表（9W）",
  linkage: "关联",
  linkage_op: "关联操作符",
  member_linkage: "会员关联",
  risk_weight: "风险权重",
  full_linkage: "完整关联",
  total_risk_score: "总风险评分",
  linkage_value: "关联值",
  source_occurrence_count: "来源出现次数",
  source_last_seen_at: "最后出现时间（来源）",
  target_occurrence_count: "目标出现次数",
  target_last_seen_at: "最后出现时间（目标）",
  member_linkage_detail: "会员关联详情",
  merchant_uid: "商户ID",
  merchant_no: "商户编号",
  slot_view: "老虎机视图",
  settlement_list_affiliate: "结算列表（代理）",
  source: "来源",
  earning_breakdown: "收益明细",
  deposit_bonus: "存款奖金",
  winlose_turnover: "输赢/流水",
  cost: "成本",
  promotion_voucher: "优惠券",
  voucher_id: "折价券 ID",
  voucher_cash: "折价券现金",
  ticketvoucher: "工单凭证",
  ticket_voucher_list_member: "工单凭证列表（会员）",
  ticket_voucher_list: "工单凭证列表",
  pending_review_funds_voucher: "待处理与审核中的工单凭证",
  all_pending_ticket_voucher: "所有待处理工单凭证",
  ticket_voucher_detail: "工单凭证详情",
  raise_deposit_ticket_voucher: "创建充值工单凭证",
  raise_deposit_ticket_voucher_gateway: "创建充值工单凭证（网关）",
  sos: "SOS 充值",
  sos_accumulate_deposit: "SOS 充值（累计存款）",
  greeting: "问候语",
  message: "消息",
  get_voucher: "获取凭证",
  get_message: "获取消息",
  voucher: "凭证",
  code: "代码",
  redeemed_by: "兑换人",
  redeemed_by_operator: "兑换人（操作员）",
  redeemed_at: "兑换时间",
  created_at: "创建时间",
  redeemed: "已兑换",
  member_sos_click_log: "会员 SOS 点击记录",
  member_wallet_voucher_log: "会员钱包凭证记录",
  member_voucher_redeemed_log: "会员凭证兑换记录",
  action_by_operator: "操作（操作员）",
  redeem_cash: "兑换现金",
  generate_voucher: "生成凭证",
  url_api_freecredit: "免费信用回调 URL",
  prefix_freecredit: "免费信用前缀",
  free_credit_member: "免费信用会员",
  free_credit_provider: "免费信用供应商",
  ticket_detail_fcp: "工单详情（免费信用供应商）",
  ticket_list_processed: "工单列表（已处理）",
  mission: "任务",
  non_slot_view: "非老虎机视图",
  banner: "横幅",
  trigger: "触发器",
  event_type: "事件类型",
  action_type: "动作类型",
  msg_greeting: "问候语（消息）",
  msg_title: "标题（消息）",
  msg_body: "内容（消息）",
  send_message: "发送消息",
  promo_type: "促销类型",
  repeatable: "重复",
  rules: "规则",
  clear_outstanding_log: "清除未结清记录",
  free_credit_withdrawal_amount: "免费额度提款金额",
  fc_withdrawal_amount: "FC 提款金额",
  frozen: "冻结",
  transferred: "已转移",
  voucher_balance: "优惠券余额",
  adjust_voucher_balance: "调整优惠券余额",
  free_game_provider: "免费游戏供应商",
  check_free_spin: "检查免费旋转",
  freespin_log: "免费旋转日志",
  current_round: "当前回合",
  lines: "线数",
  expiry_interval_days: "到期间隔（天）",
  assign: "分配",
  game_code: "游戏代码",
  clear_free_credit: "清除免费额度",
  deposit_tier: "存款等级",
  point: "积分",
  top: "顶部",
  bottom: "底部",
  leaderboard_banner: "排行榜横幅",
  referral_banner: "推荐横幅",
  tp_site: "Traffic Pool 网址",
  current_icon: "当前图标",
  new_icon: "新图标",
  voucher_redeemed: "优惠券已兑换",
  on_site: "站内",
  exclude_own: "排除自身",
  voucher_redeemed_detail: "优惠券兑换详情",
  gamification: "游戏化",
  reward_rain: "Reward Rain",
  total_claimed_amount: "已领取总金额",
  min_amount: "最低金额",
  max_amount: "最高金额",
  reward_rain_session: "Reward Rain 场次",
  reward_rain_session_claim: "Reward Rain 场次领取",
  reward_amount: "奖励金额",
  cta: "CTA",
  api_email: "API邮箱",
  api_password: "API密码",
  url_callback_voucher: "优惠券 Callback URL",
  prefix_voucher: "优惠券前缀",
  slide_show: "幻灯片播放",
  ewallet_withdrawal: "电子钱包提款",
  news: "新闻",
  slug: "网址别名",
  preview_body: "内容预览",
  full_body: "完整内容",
  normal: "普通",
  free_balance: "免费余额",
  schema: "架构",

  tt_pixel_id: "TT Pixel ID",
  tt_token: "TT Token",

  free_spin_bulk_issue : "免费旋转（批量发放）",
};